<template>
  <div
    class="tab-item"
    :class="{ 'tab-item--active': props.currentTab == props.val }"
    @click="onClickTab(props.val)"
  >
    <span class="tab-item__sign">{{ props.label }}</span>

    <slot> </slot>
  </div>
</template>

<script lang="ts" setup>
import { PropType, inject } from 'vue'
import { ModelThrowComponentsTab } from '..'

const props = defineProps({
  val: {
    default: null,
    type: [String, Number] as PropType<ModelThrowComponentsTab>
  },
  currentTab: {
    default: null,
    type: [String, Number] as PropType<ModelThrowComponentsTab>
  },
  label: {
    default: null,
    type: String as PropType<string | null>
  }
})

const onClickTab: ((activeTab: ModelThrowComponentsTab) => number) | undefined =
  inject('injectFromTab')
</script>

<style lang="scss">
@import "./style.scss";
</style>
